import { makeStyles } from '@material-ui/core/styles';
import { calculateHeight, calculateWidth, rem, vw } from '../../common/helpers/dimension-helper';
import { themeColor } from '../../mui-theme';
import { vh } from 'src/common/helpers/dimension-helper';

export const styles = makeStyles(theme => ({
  item: {
    width: '55.93vw',
    fontSize: rem(1.125),
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: calculateHeight(20).stringValue,
    letterSpacing: '1.25px',
    color: themeColor.modalTitle,
  },
  subHeading: {
    fontSize: rem(1.125),
    display: 'inline-block',
    top: '30%',
    position: 'relative',
  },
  selectedSubHeading: {
    color: themeColor.bigstones,
  },
  uncheckedSubHeading: {
    color: theme.palette.info.dark,
  },
  outerMostContainer: {
    width: '0',
    marginLeft: '1vh',
  },
  background: {
    backgroundColor: themeColor.lightBackground,
  },
  cashbackContainer: {
    padding: 10,
  },
  outerFlexDesign: {
    flex: '1 1 0',
  },
  cashbackTitleContainer: {
    height: calculateHeight(67.64).stringValue,
  },
  cashbackAmountTitleBar: {
    color: themeColor.infoMain,
    borderTop: `0.5vw solid ${theme.palette.secondary.main}`,
    height: calculateHeight(4.9).stringValue,
    width: calculateWidth(50).stringValue,
  },
  priceOverrideTitleHeader: {
    color: themeColor.modalTitle,
  },
  fitHeight: {
    height: 'fit-content',
  },
  flexDesign: {
    flex: 1,
  },
  selfAlign: {
    alignSelf: 'flex-end',
  },
  buttonStyles: {
    lineHeight: '1.14',
    letterSpacing: '0.05rem',
    fontSize: vh(2.08),
    '&:hover': {
      boxShadow: 'none',
    },
  },
  keypadContainer: {
    alignSelf: 'flex-end',
  },
  codeTitleBar: {
    letterSpacing: 0.44,
    lineHeight: 1.25,
    borderTop: `0.5vw solid ${themeColor.modalTitle}`,
    marginTop: vh(4),
    width: vw(4),
  },
  codeContainerTitleHeader: {
    color: themeColor.modalTitle,
  },
  totalPaymentText: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    letterSpacing: '0.25px',
    alignItems: 'center',
    color: '#5D6B72',
  },
  headLine: {
    display: 'flex',
    flexDirection: 'column',
    gap: vh(1),
    alignItems: 'center',
  },
}));
